import {
  AgentResourceELMA365AppSettingsTypeEnum,
  AgentResourceELMA365FileSettingsTypeEnum,
  AgentResourceELMA365SessionSettingsTypeEnum,
  AgentResourceModel,
  AgentResourceTextSettingsTypeEnum,
} from '../../../../gamma-api';

import {
  AgentResourceELMA365AppSettingsType,
  AgentResourceELMA365FileSettingsType,
  AgentResourceELMA365SessionSettingsType,
  AgentResourceTextSettingsType,
} from './types';

export const EMPTY_AGENT_RESOURCE_TEXT_SETTINGS: AgentResourceTextSettingsType = {
  type: AgentResourceTextSettingsTypeEnum.Text,
  content: '',
};

export const EMPTY_AGENT_RESOURCE_ELMA365_APP_SETTINGS: AgentResourceELMA365AppSettingsType = {
  type: AgentResourceELMA365AppSettingsTypeEnum.Elma365App,
  view_url: '',
  base_url: '',
  namespace: '',
  code: '',
  id: '',
};

export const EMPTY_AGENT_RESOURCE_ELMA365_SESSION_SETTINGS: AgentResourceELMA365SessionSettingsType = {
  type: AgentResourceELMA365SessionSettingsTypeEnum.Elma365Session,
  view_url: '',
  base_url: '',
  session_id: '',
};

export const EMPTY_AGENT_RESOURCE_ELMA365_FILE_SETTINGS: AgentResourceELMA365FileSettingsType = {
  type: AgentResourceELMA365FileSettingsTypeEnum.Elma365File,
  view_url: '',
  base_url: '',
  file_id: '',
};

export const resourceSettingsMap = {
  [AgentResourceTextSettingsTypeEnum.Text]: EMPTY_AGENT_RESOURCE_TEXT_SETTINGS,
  [AgentResourceELMA365AppSettingsTypeEnum.Elma365App]: EMPTY_AGENT_RESOURCE_ELMA365_APP_SETTINGS,
  [AgentResourceELMA365SessionSettingsTypeEnum.Elma365Session]: EMPTY_AGENT_RESOURCE_ELMA365_SESSION_SETTINGS,
  [AgentResourceELMA365FileSettingsTypeEnum.Elma365File]: EMPTY_AGENT_RESOURCE_ELMA365_FILE_SETTINGS,
};

export const EMPTY_AGENT_RESOURCE: AgentResourceModel = {
  resource_id: '',
  agent_id: '',
  thread_id: '',
  name: '',
  settings: EMPTY_AGENT_RESOURCE_TEXT_SETTINGS,
};
